let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <entryOrder>
        <entryOrderCode>入库单号, string (50) , 必填</entryOrderCode>
        <ownerCode>货主编码, string (50)</ownerCode>
        <warehouseCode>仓库编码, string (50)，必填</warehouseCode>
        <entryOrderId>仓储系统入库单ID, string (50)</entryOrderId>
        <entryOrderType>入库单类型, string (50), 例如: CGRK=采购入库、DBRK=调拨入库 、THRK=退货入库, QTRK=其他入库等(只传英文编码)</entryOrderType>
        <outBizCode>外部业务编码, string (50), 消息ID, 用于去重，因为网络等原因导致重复传输，请求不会被重复处理。一单需要多次确认时条件必填</outBizCode>
        <confirmType>支持入库单多次收货, int, 多次收货后确认时 0=入库单最终状态确认, 1=入库单中间状态确认, 每次入库传入的数量为增量, 特殊情况, 同一入库单, 如果先收到0, 后又收到1, 允许修改收货的数量</confirmType>
        <status>入库单状态, string (50), NEW=未开始处理,ACCEPT=仓库接单,PARTFULFILLED=部分收货完成,FULFILLED=收货完成,CANCELED=取消,CLOSED=关闭,CANCELEDFAIL=取消失败(只传英文编码)，必填</status>
        <orderFinishedTime>订单完成时间, string (19), YYYY-MM-DD HH:MM:SS</orderFinishedTime>
        <receiver>收货人, string (50)</receiver>
        <remark>备注, string (100)</remark>
        <userDefined1>用户自定义1, string (50)</userDefined1>
        <userDefined2>用户自定义2, string (50)</userDefined2>
        <userDefined3>用户自定义3, string (50)</userDefined3>
        <userDefined4>用户自定义4, string (50)</userDefined4>
    </entryOrder>
    <orderLines>
        <orderLine>
            <lineNo>行号, int</lineNo>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品ID, string (50)</itemId>
            <planQty>应收商品数量, float</planQty>
            <actualQty>实收数量, float, 必填</actualQty>
            <serialNo>序列号, 多个序列号用英文逗号隔开</serialNo>
            <batchs>
              <batch>
                <actualQty>实收商品数量, float, 必填</actualQty>
                <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
                <virtualWarehouse>虚拟仓库, string (50), 条件必填, 条件为使用虚拟仓库</virtualWarehouse>
                <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
                <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
                <batchCode>批次号, string (50)</batchCode>
                <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                <userDefined1>自定义批次1, string (50)</userDefined1>
                <userDefined2>自定义批次2, string (50)</userDefined2>
                <userDefined3>自定义批次3, string (50)</userDefined3>
                <userDefined4>自定义批次4, string (50)</userDefined4>
              </batch>
            </batchs>
            <customField1>自定义字段1, string (50)</customField1>
            <customField2>自定义字段2, string (50)</customField2>
            <customField3>自定义字段3, string (50)</customField3>
            <customField4>自定义字段4, string (50)</customField4>
            <customField5>自定义字段5, string (50)</customField5>
            <customField6>自定义字段6, string (50)</customField6>
            <customField7>自定义字段7, string (50)</customField7>
            <customField8>自定义字段8, string (50)</customField8>
        </orderLine>
    </orderLines>
    <orderDetails>
        <detail>
            <boxNo>容器号, string (50) </boxNo>
            <epc>epc码, string (50), 适用于RFID标签场景</epc>
        </detail>
    </orderDetails>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`

let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.entryorder.confirm.js